var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAudience = function SvgAudience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14.998 5.967a.504.504 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15 2.15 2.15 0 1 1 2.225 2.15ZM14.138 12.034c1.142.191 2.4-.009 3.284-.6 1.175-.784 1.175-2.067 0-2.85-.892-.592-2.167-.792-3.309-.592M4.973 5.967a.504.504 0 0 1 .159 0 2.144 2.144 0 0 0 2.066-2.15c0-1.192-.958-2.15-2.15-2.15a2.15 2.15 0 0 0-.075 4.3ZM5.833 12.034c-1.142.191-2.4-.009-3.284-.6-1.175-.784-1.175-2.067 0-2.85.892-.592 2.167-.792 3.309-.592M10.002 12.192a.506.506 0 0 0-.158 0 2.144 2.144 0 0 1-2.067-2.15 2.15 2.15 0 1 1 4.3 0c-.008 1.166-.925 2.116-2.075 2.15ZM7.577 14.817c-1.175.783-1.175 2.067 0 2.85 1.333.891 3.516.891 4.85 0 1.175-.784 1.175-2.067 0-2.85-1.325-.883-3.517-.883-4.85 0Z"
  })));
};
export default SvgAudience;